import { FC } from "react";

import { I18nKeyType } from "@/i18n";

import { DriverFlowBottomButtonPropsType } from "../blocks";
import {
  DsInput,
  DsInputPropsType,
  DsTextArea,
  DsTextAreaPropsType,
} from "../components/ui";
import { JobServiceTaskBaseType } from "../domain/task";
import { DriverStepScreenWrapper } from "./DriverStepScreenWrapper";

type DriverScreenWithTextInputPropsBaseType = JobServiceTaskBaseType & {
  title: I18nKeyType;
  titlei18nOptions?: object;
  bottomButtonProps: DriverFlowBottomButtonPropsType;
  shouldShowTopActionButton?: boolean;
};

type DriverScreenWithTextInputPropsType =
  DriverScreenWithTextInputPropsBaseType & {
    shouldRenderAsTextArea?: false;
    inputProps: DsInputPropsType;
  };

type DriverScreenWithTextAreaPropsType =
  DriverScreenWithTextInputPropsBaseType & {
    shouldRenderAsTextArea?: true;
    inputProps: DsTextAreaPropsType;
  };

type DriverScreenWithTextInputFinalPropsType =
  | DriverScreenWithTextInputPropsType
  | DriverScreenWithTextAreaPropsType;

const DriverScreenWithTextInput: FC<
  DriverScreenWithTextInputFinalPropsType
> = ({
  title,
  titlei18nOptions,
  jobId,
  serviceId,
  taskId,
  bottomButtonProps,
  inputProps,
  shouldShowTopActionButton,
  shouldRenderAsTextArea,
}) => {
  return (
    <DriverStepScreenWrapper
      jobId={jobId}
      serviceId={serviceId}
      taskId={taskId}
      title={title}
      titlei18nOptions={titlei18nOptions}
      shouldShowTopActionButton={shouldShowTopActionButton}
      {...bottomButtonProps}>
      {shouldRenderAsTextArea ? (
        <DsTextArea {...inputProps} />
      ) : (
        <DsInput {...(inputProps as DsInputPropsType)} />
      )}
    </DriverStepScreenWrapper>
  );
};

export { DriverScreenWithTextInput };
